import React, { useState, useEffect, useRef } from "react";
import Cards from "../../dynamic-components/Cards";
import HomeTable from "./HomeTable";
import Message from "../../utils/modals/Message";
import FullModal from "../../utils/modals/FullModal";
import { getCardsSetData } from "../../../context/api/cards/customer/getCardsSetData";
import { getTableDataSet } from "../../../context/api/tables/home/getTableDataSet";
import {
  homeSwitcher_1,
  homeSwitcher_2,
} from "../../utils/extra/cards/swichers";
import { getCustomerPdfApi } from "../../../context/api/reports/customer-reports/getCustomerPdfApi";
import Spinner from "react-bootstrap/Spinner";

const Index = ({ lang, cookies }) => {
  const initialMessageRes = {
    success: Boolean,
    message: String,
    isShow: false,
  };

  const [showFullModal, setShowFullModal] = useState({
    isShow: false,
  });
  const fetched = useRef(false);
  const cardAction = useRef();
  const [activeCard, setActiveCard] = useState("totalCustomers");
  const [messageResponse, setMessageResponse] = useState(initialMessageRes);
  const [cardsData, setCardsData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [tableLoader, setTableLoader] = useState(true);
  const [refreshData, setRefreshData] = useState(0);
  const [btnLoader, setBtnLoader] = useState(false);

  const fetchOnStart = async () => {
    fetched.current = false;
    await getCardsSetData(lang, setMessageResponse, cookies, setCardsData);
    await getTableDataSet(
      lang,
      setMessageResponse,
      cookies,
      activeCard,
      setTableData,
      setTableLoader
    );
    fetched.current = true;
  };

  useEffect(() => {
    fetchOnStart();
  }, [refreshData]);

  if (!fetched.current) {
    return (
      <div className="page_loader">
        <Spinner animation="border" variant="warning" />
      </div>
    );
  }
  const dataCard1 = cardsData.rightArray;
  const dataCard2 = cardsData.leftArray;

  const fetchTableData = async (key) => {
    setTableLoader(() => true);
    cardAction.current = key;
    await getTableDataSet(
      lang,
      setMessageResponse,
      cookies,
      cardAction.current,
      setTableData,
      setTableLoader
    );
  };

  const getPdf = async () => {
    setBtnLoader(() => true);
    await getCustomerPdfApi(cookies, setMessageResponse, setBtnLoader);
  };
  return (
    <>
      <Message
        messageResponse={messageResponse}
        close={() => setMessageResponse(initialMessageRes)}
        lang={lang}
      />

      <div className="home_p" dir={lang === "AR" ? "rtl" : "ltr"}>
        <FullModal
          lang={lang}
          data={showFullModal}
          onHide={() => {
            setRefreshData((prev) => prev + 1);
            setShowFullModal((prev) => ({ ...prev, isShow: false }));
          }}
        />
        <Cards
          pageClass="home_p"
          lang={lang}
          dataCard1={dataCard1}
          dataCard2={dataCard2}
          switcher_1={homeSwitcher_1}
          switcher_2={homeSwitcher_2}
          activeCard={activeCard}
          setActiveCard={setActiveCard}
          fetchTableData={fetchTableData}
        />
        <HomeTable
          lang={lang}
          setShowFullModal={setShowFullModal}
          tableData={tableData}
          loader={tableLoader}
          setRefreshData={setRefreshData}
          btnLoader={btnLoader}
          getPdf={getPdf}
        />
      </div>
    </>
  );
};

export default Index;
